// extracted by mini-css-extract-plugin
module.exports = {"Navbar":"Nav_Navbar__3vX_9","Sticky":"Nav_Sticky__21kMj","DesktopOnly":"Nav_DesktopOnly__3wvE8","ErrorBox":"Nav_ErrorBox__2e219"};